import { accountIdFormat } from "@redotech/redo-account-id";
import {
  consolidationGroupIdFormat,
  consolidationScheduleIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const updateConsolidationScheduleAssignments = {
  name: "updateConsolidationScheduleAssignments" as const,
  input: z.object({
    consolidationScheduleId: consolidationScheduleIdFormat.schema,
    groupIds: z.array(consolidationGroupIdFormat.schema),
    merchantAccountIds: z.array(accountIdFormat.schema),
  }),
  output: z.object({}),
};
